import { z } from 'zod';

/**
 * Tipi di notifica (lista controllata trasversale). `text` + `z.enum` come tutte
 * le altre: aggiungerne uno è solo codice più il CHECK a DB.
 */
export const TipoNotifica = z.enum([
  'task_assegnato',
  'fase_assegnata',
  'scadenza_assegnata',
  'aggiunto_al_team',
  'scadenza_imminente',
  'task_in_scadenza',
  'verbale_pronto',
  'export_pronto',
]);
export type TipoNotifica = z.infer<typeof TipoNotifica>;

/** Cosa ricorda un promemoria: una scadenza di progetto o un task. */
export const OggettoPromemoria = z.enum(['scadenza', 'task']);
export type OggettoPromemoria = z.infer<typeof OggettoPromemoria>;
